export default __webpack_public_path__ + "static/media/home_product_img1_Cn.b6636dfc.webp";